module.exports = __webpack_public_path__ + "media/images/logo_purple-745e957adc29d7e69ac67fcdfa17ab52.png";